export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5478.ff9e4f58.jpg";